import eight from '../assets/svg/projects/eight.svg';
import six from '../assets/svg/projects/six.svg';
import twelve from '../assets/svg/projects/twelve.svg';
import two from '../assets/svg/projects/two.svg';

export const projectsData = [
  {
    id: 1,
    projectName: 'Url-shortener',
    projectDesc: 'This is a url shortener full stack application',
    tags: ['Node', 'Express', 'MongoDB', 'React', 'CSS', 'MaterialUI'],
    code: 'https://github.com/Ayush-k-Shukla/URL-shortener',
    demo: 'https://tiny-ur.netlify.app/',
    image: eight,
  },
  {
    id: 2,
    projectName: 'Gmail MCP Server with RAG',
    projectDesc:
      'It is a Gmail MCP server with Retrieval-Augmented Generation support',
    tags: ['Node', 'ChromDB', 'Xenova Transformers', 'MCP'],
    code: 'https://github.com/Ayush-k-Shukla/gmail-mcp-server',
    demo: 'https://github.com/Ayush-k-Shukla/gmail-mcp-server',
    image: twelve,
  },
  {
    id: 3,
    projectName: 'Fitness Microservice',
    projectDesc:
      'It is a Fitness Microservice with Spring Boot and Gemini AI integration',
    tags: ['Spring Boot', 'Java', 'PostgreSQL,', 'MongoDB','RabbitMQ','Eureka','Gemini AI'],
    code: 'https://github.com/Ayush-k-Shukla/fitness-microservice',
    image: two,
  },
  {
    id: 4,
    projectName: 'WeShare',
    projectDesc:
      'This project is Simple Blog sharing application with complex functionalities.',
    tags: ['React', 'Node', 'Express', 'MongoDB', 'MaterialUI', 'Redux'],
    code: 'https://github.com/Ayush-k-Shukla/weshareFrontend',
    demo: 'https://wesharefor.netlify.app/',
    image: six,
  },
  {
    id: 5,
    projectName: 'Web Block Editor',
    projectDesc: 'This project is a interactive web block editor',
    tags: ['React', 'TailwindCSS', 'Redux'],
    code: 'https://github.com/Ayush-k-Shukla/scratch-playground-clone',
    demo: 'https://scratch-playground-ayush.netlify.app/',
    image: eight,
  },
  {
    id: 6,
    projectName: 'Image Search',
    projectDesc: `It is a comprehensive image search project utilizing the Unsplash API.`,
    tags: ['React', 'CSS', 'Axios'],
    code: 'https://github.com/Ayush-k-Shukla/Image-search',
    demo: 'https://image-search-xi-liart.vercel.app/',
    image: eight,
  },
];
